import type { MapCardOrgProfile, OrganisationPublicReadView, OrganisationReadView } from '../types/types';

/** Map-card profile from slim public single-org JSON (GET /v1/organisations/public/{id}). */
export function toMapCardOrgProfileFromPublicRead(row: OrganisationPublicReadView): MapCardOrgProfile {
  return {
    name: row.name,
    displayName: row.displayName ?? null,
    keywords: row.keywords ?? [],
    keywordsAuto: row.keywordsAuto,
    vatNumber: row.vatNumber ?? null,
    identificationNumber: row.identificationNumber,
    customUiIcon: row.customUiIcon ?? null,
    customUiColor: row.customUiColor ?? null,
    referralLink: row.referralLink ?? null
  };
}

/** Build map-card profile from authenticated org read (GET /v1/organisations/{id}) for admin preview. */
export function organisationReadViewToMapCardOrgProfile(read: OrganisationReadView): MapCardOrgProfile {
  return {
    name: read.name,
    displayName: read.displayName ?? null,
    keywords: read.keywords ?? [],
    keywordsAuto: read.keywordsAuto,
    vatNumber: read.vatNumber ?? null,
    identificationNumber: read.identificationNumber,
    customUiIcon: read.customUiIcon ?? null,
    customUiColor: read.customUiColor ?? null,
    referralLink: read.referralLink ?? null,
    firstActiveAddressId: read.firstActiveAddressId ?? null
  };
}
